import React, { useState, useEffect } from 'react';
import { Grid, TextField, Card, CardContent, Typography, Button } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Stack from '@mui/material/Stack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

function AddEducationDetails({ formData, handleFormDataChange, setValue }) {
    const [fileNames, setFileNames] = useState({});

    // Initialize fileNames from formData on mount
    useEffect(() => {
        const initialFileNames = {};
        educationLevels.forEach((level) => {
            if (formData.education?.[level.key]?.fileName) {
                initialFileNames[level.key] = formData.education[level.key].fileName;
            }
        });
        setFileNames(initialFileNames);
    }, [formData]);

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const handleFileChange = (level) => async (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileNames((prev) => ({
                ...prev,
                [level]: file.name
            }));

            try {
                const base64 = await convertToBase64(file);
                handleFormDataChange('education', {
                    ...formData.education,
                    [level]: {
                        ...formData.education?.[level],
                        file: base64,
                        fileName: file.name, // Store fileName
                        path: `documents/education/${level}`
                    }
                });
            } catch (error) {
                console.error('Error converting file:', error);
            }
        }
    };

    const handleEducationChange = (level, field) => (event) => {
        handleFormDataChange('education', {
            ...formData.education,
            [level]: {
                ...formData.education?.[level],
                [field]: event.target.value
            }
        });
    };

    const educationLevels = [
        { key: 'sslc', label: 'SSLC' },
        { key: 'hlc', label: 'HSC' },
        { key: 'diploma', label: 'Diploma' },
        { key: 'bachelor', label: 'Bachelor Degree' },
        { key: 'master', label: 'Master Degree' }
    ];

    const fields = [
        { name: 'institution', label: 'Institution Name', type: 'text' },
        { name: 'department', label: 'Department', type: 'text' },
        { name: 'perc', label: 'Percentage', type: 'float' },
        { name: 'year_of_passing', label: 'Year of Passing', type: 'number' }
    ];

    const handleNext = () => {
        setValue('Experience');
    };

    return (
        <Card sx={{ margin: 2 }}>
            <CardContent>
                <Typography color="#1976d2" gutterBottom sx={{ fontSize: '20px', marginBottom: '20px' }}>
                    <strong style={{ fontWeight: 600 }}>Education Details</strong>
                </Typography>
                {educationLevels.map((level) => (
                    <Card key={level.key} sx={{ marginBottom: 3, padding: 2 }}>
                        <Typography variant="h6" color="#1976d2" gutterBottom marginBottom={3}>
                            {level.label}
                        </Typography>
                        <Grid container spacing={5.5}>
                            {fields.map((field) => (
                                <Grid item xs={12} sm={6} md={4} key={field.name}>
                                    <TextField
                                        fullWidth
                                        label={field.label}
                                        type={field.type}
                                        value={formData.education?.[level.key]?.[field.name] || ''}
                                        onChange={handleEducationChange(level.key, field.name)}
                                        InputLabelProps={{ shrink: true }}
                                        size='small'
                                        sx={{
                                            width: "100%",
                                        }}
                                    />
                                </Grid>
                            ))}
                            <Grid item xs={12} sm={6} md={4}>
                                <input
                                    type="file"
                                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                    onChange={handleFileChange(level.key)}
                                    style={{ display: 'none' }}
                                    id={`file-${level.key}`}
                                />
                                <label htmlFor={`file-${level.key}`}>
                                    <Button
                                        variant="outlined"
                                        component="span"
                                        startIcon={<CloudUploadIcon />}
                                        size='medium'
                                        sx={{
                                            width: "100%",
                                            padding: '7px 0px',
                                        }}
                                    >
                                        {/* <console className="log">{fileNames[level.key] || formData.education?.[level.key]?.fileName}</console> */}
                                        {fileNames[level.key] || formData.education?.[level.key]?.fileName || 'Upload Certificate'}
                                    </Button>
                                </label>
                                {formData.education?.[level.key]?.file && (
                                    <Typography
                                        variant="caption"
                                        display="block"
                                        sx={{
                                            mt: 1,
                                            color: 'green'
                                        }}
                                    >
                                        File saved successfully
                                    </Typography>
                                )}
                            </Grid>
                        </Grid>
                    </Card>
                ))}
                <Grid item lg={12} sx={{ height: "80px", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                    <Stack direction="row" spacing={2}>
                        <Button
                            variant="contained"
                            endIcon={<ArrowForwardIcon />}
                            onClick={handleNext}
                        >
                            Next
                        </Button>
                    </Stack>
                </Grid>
            </CardContent>
        </Card>
    );
}

export default AddEducationDetails;